




















































import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import { FocusableElement, useAsyncModal } from '@front-app/hooks/useAsyncModal';
import { FullOrganization } from '@front-app/services/OrganizationsApi/OrganizationModel';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { readImageFileAsUrlWithMimeType } from '@front-app/util/image';
import {
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { VueConstructor } from 'vue';
import { EditableSection } from '../editableProfileSections';
import AvatarCropper from './AvatarCropper.vue';

const loadEditModal = () => import(/* webpackChunkName: "editProfileModal" */'@front-app/components/userProfile/editing/EditorEntry.vue')
	.then((_) => _.default as VueConstructor);

const loadCreateOrganizationModal = () => import(/* webpackChunkName: "createOrganizationForm" */'@front-app/modules/organization/components/CreateOrganizationForm.vue')
	.then((_) => _.default as VueConstructor);

export default defineComponent({
	components: {
		SlidingPanel,
		AvatarCropper,
	},
	props: {
		editSection: {
			type: Number as PropType<EditableSection>,
			default: EditableSection.NONE,
		},
		returnTo: {
			type: Element as PropType<FocusableElement | undefined>,
			default: undefined,
		},
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
		editExperienceId: {
			type: Number as PropType<number | null>,
			required: false,
			default: undefined,
		},
		isLoading: Boolean,
		isError: Boolean,
		isSuccess: Boolean,
	},
	setup(props) {
		// Primary modal
		const {
			isModalVisible: isEditModalOpen,
			modalView: editModalView,
			showModal: showEditModal,
			closeModal: closeEditModal,
		} = useAsyncModal('TMP', loadEditModal);
		watch(() => props.editSection, (curr: EditableSection) => {
			if (curr === EditableSection.NONE) {
				closeEditModal();
				return;
			}
			showEditModal(props.returnTo);
		});
		// END Primary modal

		// Create organization modal
		const {
			isModalVisible: isCreateOrganizationModalOpen,
			modalView: createOrganizationModalView,
			showModal: showCreateOrganizationModal,
			closeModal: closeCreateOrganizationModal,
		} = useAsyncModal('TMP', loadCreateOrganizationModal);
		const initialOrganizationName = ref('');
		const startCreateOrganization = (val: string, returnTo: FocusableElement) => {
			initialOrganizationName.value = val;
			showCreateOrganizationModal(returnTo);
		};
		const handleNewOrganization = (result: FullOrganization) => {
			const currentOccupation = {
				employer: { id: result.id },
			};
			CurrentUserStore.actions.update({ currentOccupation });
			closeCreateOrganizationModal();
		};
		// END Create organization modal

		// Avatar modal
		const isAvatarCropperVisible = ref(false);
		const avatarUrl = ref('');
		const avatarMimeType = ref('');
		const requestAvatarCrop = async (file: File) => {
			URL.revokeObjectURL(avatarUrl.value);
			const {
				mimeType,
				imageUrl,
			} = await readImageFileAsUrlWithMimeType(file);
			avatarUrl.value = imageUrl;
			avatarMimeType.value = mimeType;
			isAvatarCropperVisible.value = true;
		};
		// END avatar modal

		return {
			// Edit modal
			EditableSection,
			isEditModalOpen,
			editModalView,
			closeEditModal,
			// Create modal
			isCreateOrganizationModalOpen,
			createOrganizationModalView,
			initialOrganizationName,
			startCreateOrganization,
			closeCreateOrganizationModal,
			handleNewOrganization,
			// Avatar modal
			requestAvatarCrop,
			avatarUrl,
			avatarMimeType,
			isAvatarCropperVisible,
		};
	},
});
